define('models/dataprovider',["T1", "T1Model"], function (T1, T1Model) {
  T1.Models.DataProvider = T1Model.extend({
    url: "pixel_providers/",
    fixture: "-pixel_providers"
  });
  return T1.Models.DataProvider;
});
